import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { emptyArray } from 'ui-components/default-props/empty';
import Global from '../../../../store/global-selectors';
import { trackShipmentRequest } from '../../../../store/ltl/ltl.actions';
import { freightActionButtonMessages } from './messages';

import style from '../../../../components/grid-header/shared-classes.module.less';

export const TrackFreightButton = () => {
  const dispatch = useDispatch();
  const selectedShipmentIds = useSelector(Global.selectLtlGridSelectedShipmentIds) ?? emptyArray;
  const firstSelectedId = selectedShipmentIds[0];
  const shipment = useSelector((state: unknown) =>
    firstSelectedId ? Global.selectEntitiesFreightShipmentById(state, { freightShipmentId: firstSelectedId }) : null,
  );

  const handleClick = useCallback(() => {
    if (!shipment?.proNumber) {
      return;
    }
    dispatch(trackShipmentRequest(shipment.proNumber, 'PRO'));
  }, [dispatch, shipment]);

  return (
    <Button className={style['action-button']} disabled={!shipment?.proNumber} onClick={handleClick} theme='tertiary'>
      <FormattedMessage {...freightActionButtonMessages.trackFreight} />
    </Button>
  );
};
